export default {"src":"/_next/static/media/tailored-content.125ffc3e.svg","height":380,"width":427,"blurWidth":0,"blurHeight":0};